import axios from 'axios';

const API_URL = import.meta.env.VITE_API_URL || '/api/v1';

class ContractService {
  /**
   * Fetch questionnaire configuration for a specific jurisdiction and state
   */
  async getQuestionnaire(jurisdiction, state) {
    try {
      // Call the backend API endpoint for questionnaire
      let url = `${API_URL}/${jurisdiction}/questionnaire/`;
      // For USA, append state parameter
      if (jurisdiction === 'usa' && state && state !== 'default') {
        url = `${API_URL}/${jurisdiction}/questionnaire/${state}/`;
      }
      const response = await axios.get(url);
      return response.data;
    } catch (error) {
      console.error('Error fetching questionnaire:', error);
      throw error;
    }
  }

  /**
   * Create a new contract from questionnaire data
   */
  async createContract(jurisdiction, contractData) {
    try {
      const response = await axios.post(
        `${API_URL}/${jurisdiction}/contracts/create/`,
        contractData
      );
      return response.data;
    } catch (error) {
      console.error('Error creating contract:', error);
      throw error;
    }
  }

  /**
   * Get contract details by ID
   */
  async getContract(jurisdiction, contractId) {
    try {
      const response = await axios.get(
        `${API_URL}/${jurisdiction}/contracts/${contractId}/`
      );
      return response.data;
    } catch (error) {
      console.error('Error fetching contract:', error);
      throw error;
    }
  }

  /**
   * Get preview PDF URL
   */
  getPreviewUrl(jurisdiction, contractId) {
    return `${API_URL}/${jurisdiction}/contracts/${contractId}/preview/`;
  }

  /**
   * Create Stripe payment intent
   */
  async createPaymentIntent(contractId, amount = 2999, currency = 'usd', email = '') {
    try {
      const response = await axios.post(
        `${API_URL}/payments/create-payment-intent/`,
        {
          contract_id: contractId,
          amount: amount,
          currency: currency.toLowerCase(),
          email: email
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error creating payment intent:', error);
      throw error;
    }
  }

  /**
   * Confirm payment after Stripe processing
   */
  async confirmPayment(paymentIntentId, email = '') {
    try {
      const response = await axios.post(
        `${API_URL}/payments/confirm-payment/`,
        {
          payment_intent_id: paymentIntentId,
          email: email
        }
      );
      return response.data;
    } catch (error) {
      console.error('Error confirming payment:', error);
      throw error;
    }
  }

  /**
   * Purchase contract (deprecated - use createPaymentIntent instead)
   */
  async purchaseContract(jurisdiction, contractId, paymentToken) {
    try {
      const response = await axios.post(
        `${API_URL}/${jurisdiction}/contracts/${contractId}/purchase/`,
        { payment_token: paymentToken }
      );
      return response.data;
    } catch (error) {
      console.error('Error purchasing contract:', error);
      throw error;
    }
  }

  /**
   * Get download URL for final PDF
   */
  getDownloadUrl(jurisdiction, contractId) {
    return `${API_URL}/${jurisdiction}/contracts/${contractId}/download/`;
  }
}

export default new ContractService();
